import React from "react";
import {
  Button,
  Divider,
  Grid,
  IconButton,
  Typography,
} from "@material-ui/core";
import { DeleteForever } from "@material-ui/icons";
import AddIcon from "@material-ui/icons/Add";
import { PHONE_TYPES } from "../../constants/CoreConstants";
import { addContactV2Style } from "./AddContactV2Style";
import Utils from "../addContact/Utils";
import { PlusIcon } from "../common/Icons";
import BasicFormControlWithLabelV2 from "../custom/BasicFormControlWithLabelV2";
import BasicSelect from "../custom/BasicSelect";
import {BasicMaskedInput} from "../GlobalAddDealModalV3/GlobalAddDealModalStyles";
import BasicInput from "../custom/BasicInput";

const defaultPrimaryContact = {
  first_name: "",
  last_name: "",
  numbers: [{ number: "", number_state: "" }],
  emails: [{ email: "" }],
  birth_date: "",
};

const PrimaryContactInfoTab = ({
  commercialContactForm,
  setCommercialContactForm,
  primaryContactRef,
  removeMultiField,
}) => {
  const classes = addContactV2Style();
  const placeholderColor = "#929da9";
  const activeColor = "#36454F";

  const addPrimaryContact = () => {
    setCommercialContactForm((prev) => ({
      ...prev,
      primary_contacts: [
        ...prev.primary_contacts,
        { ...defaultPrimaryContact },
      ],
    }));
  };

  const removePrimaryContact = (indexToRemove) => {
    setCommercialContactForm((prev) => ({
      ...prev,
      primary_contacts: prev.primary_contacts.filter(
        (_, idx) => idx !== indexToRemove
      ),
    }));
  };

  const handleChange = (fieldName, value, relIndex) => {
    setCommercialContactForm((prev) => {
      const updatedPrimaryContacts = [...prev.primary_contacts];
      updatedPrimaryContacts[relIndex] = {
        ...updatedPrimaryContacts[relIndex],
        [fieldName]: value,
      };
      return {
        ...prev,
        primary_contacts: updatedPrimaryContacts,
      };
    });
  };

  const appendNumber = (relIndex) => {
    const numberObj = { number: "", number_state: "" };
    setCommercialContactForm((prev) => {
      const updatedPrimaryContacts = [...prev.primary_contacts];
      updatedPrimaryContacts[relIndex].numbers.push(numberObj);
      return { ...prev, primary_contacts: updatedPrimaryContacts };
    });
  };

  const appendEmail = (relIndex) => {
    const emailObj = { email: "" };
    setCommercialContactForm((prev) => {
      const updatedPrimaryContacts = [...prev.primary_contacts];
      updatedPrimaryContacts[relIndex].emails.push(emailObj);
      return { ...prev, primary_contacts: updatedPrimaryContacts };
    });
  };

  const handleChangeDynamicInput = (field, key, value, index, relIndex) => {
    if (field === "numbers" && key === "number") {
      if (!Utils.checkLetterExistInText(value) || value === "") {
        if (value.length > 0 && value[0] !== "1") {
          value = "1" + value;
        }
      } else {
        try {
          value = value.replace(/[^0-9]/g, "");
          if (value.length > 0 && value[0] !== "1") {
            value = "1" + value;
          }
        } catch (e) {
          console.error(e);
        }
      }

      if (value.length > 11) {
        value = value.slice(0, 11);
      }
    }

    setCommercialContactForm((prev) => {
      const updatedPrimaryContacts = [...prev.primary_contacts];
      const targetGroup = [...updatedPrimaryContacts[relIndex][field]];

      targetGroup[index] = {
        ...targetGroup[index],
        [key]: value,
      };

      updatedPrimaryContacts[relIndex] = {
        ...updatedPrimaryContacts[relIndex],
        [field]: targetGroup,
      };

      return {
        ...prev,
        primary_contacts: updatedPrimaryContacts,
      };
    });
  };

  return (
    <Grid
      container
      spacing={2}
      style={{ paddingInline: 5, marginBottom: "48px" }}
    >
      <Grid item xs={12}>
        <div style={{ width: "100%" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div
              ref={primaryContactRef}
              data-section="Primary Contact"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                paddingRight: "10px",
              }}
            >
              <Typography variant="body2" className={classes.titleStyle}>
                Primary Contact
              </Typography>
            </div>
            <div style={{ width: "100%" }}>
              <Divider />
            </div>
          </div>
        </div>
      </Grid>

      {commercialContactForm.primary_contacts?.map(
        (primaryContact, relIndex) => (
          <Grid item xs={12} key={relIndex}>
            <div
              style={{
                border: "1px solid #ccc",
                borderRadius: "8px",
                padding: "16px",
                marginBottom: "24px",
                position: "relative",
              }}
            >
              {relIndex > 0 && (
                <IconButton
                  size="small"
                  onClick={() => removePrimaryContact(relIndex)}
                  style={{ position: "absolute", top: 8, right: 8 }}
                >
                  <DeleteForever color="error" />
                </IconButton>
              )}

              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <BasicFormControlWithLabelV2
                        label={'First Name'}
                        name={`primaryContacts[${relIndex}].firstName`}
                        fullWidth
                        value={primaryContact.first_name}
                        onChange={(e) =>
                            handleChange("first_name", e.target.value, relIndex)
                        }
                        component={BasicInput}
                        sx={{
                            '& .MuiInputBase-root': {
                                marginTop: 0,
                            },
                            '& input': {
                                border: 'none !important'
                            }
                        }}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <BasicFormControlWithLabelV2
                        label={'Last Name'}
                        name={`primaryContacts[${relIndex}].lastName`}
                        fullWidth
                        value={primaryContact.last_name}
                        onChange={(e) =>
                            handleChange("last_name", e.target.value, relIndex)
                        }
                        component={BasicInput}
                        sx={{
                            '& .MuiInputBase-root': {
                                marginTop: 0,
                            },
                            '& input': {
                                border: 'none !important'
                            }
                        }}
                    />
                </Grid>

                {primaryContact.numbers.map((number, numIndex) => (
                  <Grid item xs={12} key={numIndex}>
                    <Grid container spacing={2}>
                      <Grid item xs={6} className="mask-numbr-input">
                          <BasicFormControlWithLabelV2
                              label={'Phone Number'}
                              fullWidth
                              mask={[
                                  "+",
                                  /\d/,
                                  " ",
                                  "(",
                                  /\d/,
                                  /\d/,
                                  /\d/,
                                  ")",
                                  " ",
                                  /\d/,
                                  /\d/,
                                  /\d/,
                                  "-",
                                  /\d/,
                                  /\d/,
                                  /\d/,
                                  /\d/,
                              ]}
                              className={`${classes.phoneNumberInput} MuiInputBase-input`}
                              // guide={true}
                              // keepCharPositions={true}
                              id={"number-input-field" + numIndex}
                              onChange={(e) =>
                                  handleChangeDynamicInput(
                                      "numbers",
                                      "number",
                                      e.target.value,
                                      numIndex,
                                      relIndex
                                  )
                              }
                              value={number.number}
                              component={BasicMaskedInput}
                              sx={{
                                  '& .MuiInputBase-root': {
                                      marginTop: 0,
                                  },
                                  '& input': {
                                      border: 'none !important'
                                  }
                              }}
                          />
                      </Grid>
                      <Grid item xs={6}>
                        <div style={{ display: "flex", gap: "10px" }}>
                            <BasicSelect
                                fullWidth
                                name="numberState"
                                options={PHONE_TYPES}
                                defaultText="Please Select"
                                value={number.number_state}
                                mapping={{ label: "label", value: "value" }}
                                onChange={(e) =>
                                    handleChangeDynamicInput(
                                        "numbers",
                                        "number_state",
                                        e.target.value,
                                        numIndex,
                                        relIndex
                                    )
                                }
                            />
                          {numIndex === 0 ? (
                            <div
                              className={classes.addButtonStyle}
                              onClick={() => appendNumber(relIndex)}
                            >
                              <PlusIcon fill="#FFF" />
                            </div>
                          ) : (
                            <IconButton
                              size="small"
                              onClick={() =>
                                removeMultiField("numbers", numIndex, relIndex)
                              }
                            >
                              <DeleteForever color="error" />
                            </IconButton>
                          )}
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                ))}

                {primaryContact.emails.map((email, emailIndex) => (
                  <Grid item xs={12} key={emailIndex}>
                    <div style={{ display: "flex", gap: "10px" }}>
                        <BasicFormControlWithLabelV2
                            label={'Email'}
                            type="email"
                            fullWidth
                            value={email.email}
                            onChange={(e) =>
                                handleChangeDynamicInput(
                                    "emails",
                                    "email",
                                    e.target.value,
                                    emailIndex,
                                    relIndex
                                )
                            }
                            component={BasicInput}
                            sx={{
                                '& .MuiInputBase-root': {
                                    marginTop: 0,
                                },
                                '& input': {
                                    border: 'none !important'
                                }
                            }}
                        />
                      {emailIndex === 0 ? (
                        <div
                          className={classes.addButtonStyle}
                          onClick={() => appendEmail(relIndex)}
                        >
                          <PlusIcon fill="#FFF" />
                        </div>
                      ) : (
                        <IconButton
                          size="small"
                          onClick={() =>
                            removeMultiField("emails", emailIndex, relIndex)
                          }
                        >
                          <DeleteForever color="error" />
                        </IconButton>
                      )}
                    </div>
                  </Grid>
                ))}

                <Grid item xs={12} md={6}>
                    <BasicFormControlWithLabelV2
                        label={'Date of Birth'}
                        type="date"
                        fullWidth
                        style={{color: primaryContact.birth_date ? activeColor : placeholderColor}}
                        name={`primaryContacts[${relIndex}].dob`}
                        value={primaryContact.birth_date}
                        onChange={(e) =>
                            handleChange("birth_date", e.target.value, relIndex)
                        }
                        component={BasicInput}
                        sx={{
                            '& .MuiInputBase-root': {
                                marginTop: 0,
                            },
                            '& input': {
                                border: 'none !important'
                            }
                        }}
                    />
                </Grid>
              </Grid>
            </div>
          </Grid>
        )
      )}

      <Grid item xs={12}>
        <Button
          variant="contained"
          color="primary"
          className={classes.addButton}
          disableElevation
          startIcon={<AddIcon />}
          onClick={addPrimaryContact}
        >
          Add
        </Button>
      </Grid>
    </Grid>
  );
};

export default PrimaryContactInfoTab;
